import _ from 'lodash'

export default {
  SET_STATE: (state, payload) => {
    _.set(state, payload.action, payload.data)
  },

  SET_LOADING: (state, status) => {
    state.loading = status
  },

  SET_CUSTOMER_LIST: (state, data) => {
    state.customers = [...state.customers, ...data]
  },

  SET_PRODUCT_LIST: (state, payload) => {
    if (payload.page === 1) {
      state.products_list = payload.data
    } else {
      state.products_list.push(...payload.data)
    }
  },

  /**
   * add product to invoice list
   */
  ADD_INVOICE_PRODUCTS: (state, product) => {
    state.invoice__products.push(product)
  },

  /**
   * remove item from invoice
   */
  REMOVE_INVOICE_PRODUCTS: (state, productId) => {
    state.invoice__products.splice(
      state.invoice__products.findIndex(x => x.id === productId),
      1
    )
  },

  /**
   * update invoice products value
   */
  UPDATE_INVOICE_PRODUCTS: (state, payload) => {
    const oldItems = Object.assign([], state.invoice__products)
    oldItems[payload.index] = payload.data
    state.invoice__products = oldItems
  },

  /**
   * add product to temp product list state
   * only invoice items
   *
   */
  ADD_PRODUCTS: (state, payload) => {
    payload.forEach(element => {
      const tempIndex = state.products.findIndex(x => x.id === element.id)

      if (tempIndex === -1) {
        state.products.push(element)
      } else {
        state.products[tempIndex] = element
      }
    })
  },
  /**
   * remove product from temp product list state
   * from only invoice items
   *
   */
  REMOVE_PRODUCTS: (state, id) => {
    const tempIndex = state.products.findIndex(x => x.id === id)

    if (tempIndex !== -1) {
      state.products.splice(tempIndex, 1)
    }
  }
}
